// Sometimes window.open gets blocked for popups, but this shouldn't
// Matching args from `window.open`
// Note: ensure URL is a relative path
export function openViaForm(url: string, target?: string) {
  const form = document.createElement('form');
  form.method = 'GET';
  form.action = url;
  if (target) {
    form.target = target;
  }

  document.body.appendChild(form);
  form.submit();
}
